import { useIsReduxStatesHydrated } from 'hooks/redux';
import { useEffect } from 'react';
import { HydrationStateEnum } from 'types/redux';

const RehydrationWatcher = ({
  onRehydrate,
  onTimeOut,
  watchedStates,
}: {
  onRehydrate: () => void;
  onTimeOut?: () => void;
  watchedStates: HydrationStateEnum[];
}) => {
  const reduxHydrationState = useIsReduxStatesHydrated(watchedStates);

  useEffect(() => {
    if (reduxHydrationState.rehydrated) {
      onRehydrate();
    }
  }, [onRehydrate, reduxHydrationState.rehydrated]);

  useEffect(() => {
    if (reduxHydrationState.timedOut && onTimeOut) {
      onTimeOut();
    }
  }, [onTimeOut, reduxHydrationState.timedOut]);

  return null;
};

export default RehydrationWatcher;
